import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { RsIcon } from '../icons'

export default function PortalHeader({
  title,
  searchPlaceholder = 'Search deals, investors, documents...',
  searchValue,
  onSearchChange,
  onSearchSubmit,
  showSearch = true,
  children,
}) {
  const { user, role } = useAuth()
  const initials = (user?.real_name || user?.system_name || role || 'U').charAt(0).toUpperCase()

  return (
    <div className="portal-header">
      <h1>{title}</h1>
      <div className="portal-header-right">
        {children}
        {showSearch && (
          <form
            className="portal-search-box"
            onSubmit={(e) => {
              e.preventDefault()
              onSearchSubmit?.(searchValue)
            }}
          >
            <RsIcon name="search" size="sm" aria-hidden />
            <input
              type="search"
              placeholder={searchPlaceholder}
              value={searchValue ?? ''}
              onChange={(e) => onSearchChange?.(e.target.value)}
            />
          </form>
        )}
        <span role="img" aria-label="Notifications" style={{ fontSize: 18, cursor: 'pointer', display: 'inline-flex' }}><RsIcon name="bell" size="md" /></span>
        <div className="portal-avatar">{initials}</div>
      </div>
    </div>
  )
}
